import React from 'react'
import { subscribe } from 'react-contextual'
import { InvoicesProvider } from '../../../../providers'
import { SearchFilter } from '../../..'
import styles from './SearchFilter.module.scss'

const ActiveInvoicesSearchFilter = (props: any) => (
  <SearchFilter className={styles['active-invoice-filters']} {...props} />
)

export default subscribe([InvoicesProvider], ({ location, redirect, activeInvoiceFilters }: any) => ({
  pathname: location.pathname,
  redirect,
  filters: activeInvoiceFilters,
}))(ActiveInvoicesSearchFilter)
